import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState({ mode: 'light' });

  const toggleTheme = () => {
    setTheme(prevTheme => ({
      mode: prevTheme.mode === 'light' ? 'dark' : 'light'
    }));
  };

  // Apply theme colors to CSS variables
  useEffect(() => {
    const isDark = theme.mode === 'dark';
    
    // Main colors
    document.documentElement.style.setProperty('--bg-color', isDark ? '#121212' : '#f5f5f5');
    document.documentElement.style.setProperty('--text-color', isDark ? '#f5f5f5' : '#333');
    document.documentElement.style.setProperty('--nav-bg-color', isDark ? '#1a1a1a' : '#2a5298');
    document.documentElement.style.setProperty('--card-bg-color', isDark ? '#1e1e1e' : '#ffffff');
    
    // Additional colors for better contrast
    document.documentElement.style.setProperty('--input-bg-color', isDark ? '#2c2c2c' : '#ffffff');
    document.documentElement.style.setProperty('--input-text-color', isDark ? '#f0f0f0' : '#333');
    document.documentElement.style.setProperty('--input-border-color', isDark ? '#444' : '#ddd');
    document.documentElement.style.setProperty('--button-primary-bg', isDark ? '#3a62a7' : '#2a5298');
    document.documentElement.style.setProperty('--button-primary-text', isDark ? '#ffffff' : '#ffffff');
    document.documentElement.style.setProperty('--sidebar-bg', isDark ? '#1e1e1e' : '#f8f9fa');
    document.documentElement.style.setProperty('--sidebar-border', isDark ? '#333' : '#eee');
    document.documentElement.style.setProperty('--table-header-bg', isDark ? '#2c2c2c' : '#f0f0f0');
    document.documentElement.style.setProperty('--table-border', isDark ? '#444' : '#ddd');
    document.documentElement.style.setProperty('--link-color', isDark ? '#90caf9' : '#2a5298');
    document.documentElement.style.setProperty('--call-option-color', isDark ? '#4caf50' : '#388e3c');
    document.documentElement.style.setProperty('--put-option-color', isDark ? '#f44336' : '#d32f2f');
    
    // Apply a class to the body for easier CSS targeting
    document.body.className = isDark ? 'dark-theme' : 'light-theme';
  }, [theme.mode]);

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};
